import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';
import { ResizeGapsScope } from './resizeGapsScope';

export const toggleResizeGapsUserPreferences = (scope: ResizeGapsScope) => {
  const { editorAPI } = scope;

  editorAPI.store.dispatch(
    stateManagement.userPreferences.actions.setSiteUserPreferences(
      constants.USER_PREFS.VIEW_TOOLS.SPACE_INDICATION_ENABLED,
      !getResizeGapsUserPreferences(scope),
    ),
  );
};

export const getResizeGapsUserPreferences = (scope: ResizeGapsScope) => {
  const { editorAPI } = scope;
  const resizeGapsUserPreferences =
    stateManagement.userPreferences.selectors.getSiteUserPreferences(
      constants.USER_PREFS.VIEW_TOOLS.SPACE_INDICATION_ENABLED,
    )(editorAPI.store.getState());

  return resizeGapsUserPreferences !== undefined
    ? resizeGapsUserPreferences
    : true;
};
